import { Box, Flex, Text } from '@shared/components';
import { type ReactNode } from 'react';

import ReadonlyFormRadioSelection from '../readonly-form-radio-selection/readonly-form-radio-selection';

interface ReadonlyComputerInfoFeatureCheckRowProps {
  label: string;
  value: string | null;
  options: {
    label: string | ReactNode;
    value: string;
  }[];
  otherDetails?: string | null;
  withOthers?: boolean;
}

export default function ReadonlyComputerInfoFeatureCheckRow(
  props: Readonly<ReadonlyComputerInfoFeatureCheckRowProps>,
) {
  const { label, value, options, otherDetails, withOthers } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        [theme.breakpoints.down('desktop')]: {
          flexDirection: 'column',
        },
      })}
    >
      <Box sx={{ width: '100%' }}>
        <Text variant='body1Semibold'>{label}</Text>
      </Box>
      <Flex
        sx={(theme) => ({
          flex: 1,
          flexDirection: 'row',
          alignItems: 'end',
          gap: theme.spacing(2),
          flexWrap: 'wrap',
        })}
      >
        <ReadonlyFormRadioSelection
          value={value ?? ''}
          options={options}
          withOthers={withOthers}
          otherDetails={otherDetails}
        />
      </Flex>
    </Flex>
  );
}
